export default "__VITE_ASSET__BxRabyin__"